// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".revico-widget .revico-community-talk-title {\n  margin-bottom: 20px;\n}\n.revico-widget .revico-community-talk-title--text {\n  font-size: 1.2em;\n  font-weight: bold;\n}\n.revico-widget .revico-community-talk-title .fa-message {\n  margin-right: 4px;\n  font-size: 0.9em;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
